import { deserializePremiumSermonSeries, SerializedPremiumSermonSeries } from "../../src/entities/PremiumSermonSeries";
import { WebClient } from "./server/WebClient";

export interface SavePremiumSermonSeriesRequest {
	id?: number;
	title: string;
	shortDescription: string;
	description: string;
	thumbnail?: string;
}

export interface SavePremiumSermonSeriesAssetRequest {
	premiumSeriesId: number;
	assetId: string;
}

export const PremiumSermonSeriesService = {
	getAll: () => WebClient.Get("api/PremiumSermonSeries/GetPremiumSermonSeries", (series: SerializedPremiumSermonSeries[]) => series.map(deserializePremiumSermonSeries)),
	getAllEnabled: () => WebClient.Get("api/PremiumSermonSeries/GetEnabledPremiumSermonSeries", (series: SerializedPremiumSermonSeries[]) => series.map(deserializePremiumSermonSeries)),
	get: (id: number) => WebClient.Get(`api/PremiumSermonSeries/GetPremiumSermonSeries/${id}`, deserializePremiumSermonSeries),
	getByName: (name: string) => WebClient.Post.Unvalidated(`api/PremiumSermonSeries/GetPremiumSermonSeriesByTitle`, {title: name}, deserializePremiumSermonSeries),
	purchase: (id: number) => WebClient.Put.Validated(`api/PremiumSermonSeries/Purchase/`, { id }),
	activate: (id: number) => WebClient.Post.Validated<string>(`api/PremiumSermonSeries/Activate/`, { PremiumSermonSeriesId: id })
}